import {
  Form,
  Grid,
  Image,
  message,
  Spin,
  Upload,
  UploadFile,
  UploadProps,
} from 'antd';
import { Modal } from 'components';
import { useCreateDashBoard } from 'features/Dashboard/use-cases/upload-documents';
import { useUploadImage } from 'features/Dashboard/use-cases/upload-image';
import { useUserContext } from 'features/users';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { useState } from 'react';
import { convertFileSize, validateFileBeforeUpload } from 'routes/utils';
const { useBreakpoint } = Grid;

export const UploadDocumentsModal = ({
  onClose,
  titleDocuments,
  refetch,
}: {
  onClose: () => void;
  titleDocuments: any;
  refetch: any;
}) => {
  const formName = 'add-category-form';
  const screens = useBreakpoint();
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [fileList, setFileList] = useState<any[]>([]);
  const [filenameUrl, setFileNameUrl] = useState('');
  const [previewImage, setPreviewImage] = useState<string>('');
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [isImageUploading, setIsImageUploading] = useState<boolean>(false); // Loading state for image upload
  const { isLoading: imageLoading, mutate: uploadImage } = useUploadImage();

  const [form] = Form.useForm();
  const { user } = useUserContext();
  const { mutate, isLoading } = useCreateDashBoard();

  const handleImageUpload = (file: UploadFile) => {
    const formData = new FormData();
    formData.append('file', file as any);

    setIsImageUploading(true); // Set uploading state to true
    uploadImage(
      { id: user?.CompanyId as string, formData }, // Pass id and file as payload
      {
        onSuccess: (response: any) => {
          setFileNameUrl(response.fileName);
          message.success('File uploaded successfully');
          setIsImageUploading(false); // Reset uploading state
        },
        onError: () => {
          message.error('Image upload failed');
          setIsImageUploading(false); // Reset uploading state
        },
      },
    );
  };
  const handleUpdate = () => {
    const formData = new FormData();
    const file = fileList[0]?.originFileObj;
    // Check if the file is provided
    if (!file) {
      // Show an error message or handle the case where no file is uploaded
      message.error('Please upload a file.');

      return; // Prevent further execution if no file is uploaded
    }
    formData.append('CompanyId', user?.CompanyId);
    formData.append('DocumentTypeId', titleDocuments?.documentTypeId);
    formData.append('file', file); // Include the entire file object
    const uploadedFile = fileList[0]?.originFileObj; // Assuming fileList contains the uploaded file
    if (uploadedFile) {
      // Get the filename and filesize from the file object
      const fileSize = uploadedFile.size;
      // Append filename and filesize to FormData
      formData.append('FileName', filenameUrl);
      formData.append('FileSize', convertFileSize(fileSize)); // FileSize is typically a number, so convert it to string
    }
    // formData.append('FileName', file.name);
    mutate(formData, {
      onSuccess: () => {
        refetch();
        window.location.reload(); // Reload the page
        onClose();
      },
    });
  };
  const beforeUpload = (file: any) => {
    const isValid = validateFileBeforeUpload(file);
    if (isValid) {
      handleImageUpload(file); // Call handleImageUpload only if valid
    }

    return isValid; // If false, upload will be prevented
  };
  const handlePreview = async (file: UploadFile) => {
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };
  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        title={`Upload ${titleDocuments?.documentName}`}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={'Upload'}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={screens.lg ? '520px' : '100%'}
        okButtonProps={{
          form: formName,
          loading: isLoading,
          disabled: imageLoading || isImageUploading,
        }}
        maskClosable={false}
      >
        <Form
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinish={handleUpdate}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          // disabled={isLoading}
        >
          <span className='text-xs block mb-1'>
            Accepted extensions (images, pdf, docx, xsl)
          </span>
          <Form.Item>
            <div className='upld_item '>
              <Upload
                action='https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload'
                listType='picture-card'
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                maxCount={1}
                style={{ width: '100%' }} // Ensure Upload takes full width
                beforeUpload={beforeUpload}
              >
                {fileList?.length >= 1 ? null : (
                  <div className='upld_img'>
                    <img src='/upload-img.png' alt='logo' className='' />
                    <p className='drp_text'>
                      Drag and drop here <span>or</span>{' '}
                      <a href='javascript:void(0)'>Browse Files</a>
                    </p>
                    {/* {uploadButton} */}
                  </div>
                )}
              </Upload>
              {isImageUploading && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1,
                  }}
                >
                  <Spin size='large' />
                </div>
              )}
            </div>
            {previewImage && (
              <Image
                wrapperStyle={{ display: 'none' }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
              />
            )}
          </Form.Item>
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
